/**
 * i18n setup: static UI translations from bundled locale files (manual translations).
 * No backend API for static text. Dynamic content (e.g. blog) is loaded from the server.
 */
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import languageConfig from '../config/languageConfig';

import en from '../locales/en.json';
import es from '../locales/es.json';
import fr from '../locales/fr.json';
import de from '../locales/de.json';

const defaultLang = languageConfig.defaultLanguage;
const supportedLngs = languageConfig.getLanguageCodes();

const resources = {
  en: { translation: en },
  es: { translation: es },
  fr: { translation: fr },
  de: { translation: de },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: defaultLang,
    supportedLngs,
    defaultNS: 'translation',
    interpolation: { escapeValue: false },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'preferredLanguage',
    },
    react: { useSuspense: false },
  });

export function changeLanguage(lang) {
  const valid = supportedLngs.includes(lang) ? lang : defaultLang;
  i18n.changeLanguage(valid);
  if (typeof document !== 'undefined') document.documentElement.lang = valid;
  if (typeof localStorage !== 'undefined') localStorage.setItem('preferredLanguage', valid);
  return valid;
}

export async function initI18n() {
  const stored = typeof localStorage !== 'undefined' ? localStorage.getItem('preferredLanguage') : null;
  const lang = supportedLngs.includes(stored) ? stored : defaultLang;
  await i18n.changeLanguage(lang);
  if (typeof document !== 'undefined') document.documentElement.lang = lang;
  if (typeof localStorage !== 'undefined') localStorage.setItem('preferredLanguage', lang);
  return lang;
}

export default i18n;
